module.exports = __webpack_public_path__ + "static/media/discord_icon.2f3f0da4.svg";